import { render } from "./IngresoDialog.vue?vue&type=template&id=07c9a410"
import script from "./IngresoDialog.vue?vue&type=script&lang=js"
export * from "./IngresoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__